import { ButtonApiErrorWrapper } from 'app/components/shared/ButtonApiErrorWrapper'
import { SmartFileInput } from 'app/components/shared/FormComponents/SmartFileInput'
import { Button } from 'app/components/ui/Button'
import { Form } from 'app/components/ui/Form'
import { useUploadFileUser } from 'app/queries/user'
import { pdfInputTypes } from 'app/utils/fileUtils'
import React from 'react'
import styled from 'styled-components'

import {
  InputHolderDocumentFormData,
  inputHolderDefaultValues,
  inputHolderValidationSchema,
  adaptFormDataToAPI,
} from './form'

type Props = { onSuccess?: () => void }
export const InputHolderDocumentInnerForm = ({
  onSuccess,
}: Props): JSX.Element => {
  const { mutate: uploadFile, isLoading, isError, error } = useUploadFileUser()

  const onSubmit = (data: InputHolderDocumentFormData) =>
    uploadFile(adaptFormDataToAPI(data), {
      onSuccess: () => {
        if (onSuccess) onSuccess()
      },
    })

  return (
    <Form<InputHolderDocumentFormData>
      defaultValues={inputHolderDefaultValues}
      validationSchema={inputHolderValidationSchema}
      onSubmit={onSubmit}
    >
      <FileInputGroup>
        <SmartFileInput
          label={'Carica il documento di identità del titolare'}
          name='input_holder'
          accept={pdfInputTypes.join(', ')}
          description='Formato immagine o PDF, dimensione massima 10 MB'
        ></SmartFileInput>
      </FileInputGroup>
      <ButtonApiErrorWrapper isError={isError} error={error} alignCenter>
        <Button type='submit' size='lg' disabled={isLoading}>
          {isLoading ? 'Caricamento...' : 'SALVA'}
        </Button>
      </ButtonApiErrorWrapper>
    </Form>
  )
}

const FileInputGroup = styled.div`
  margin-bottom: 2rem;

  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
`
